import { Text } from '@chakra-ui/react';
import { Checkbox } from '@time-line/components/common';
import type { ColorScheme } from 'components/heros/PromotionHero';
import type { UseFormRegisterReturn } from 'react-hook-form';

type SubscribeMarketingCheckboxProps = UseFormRegisterReturn & {
  colorScheme: ColorScheme;
};

export function SubscribeMarketingCheckbox({
  colorScheme,
  ...registration
}: SubscribeMarketingCheckboxProps) {
  return (
    <Checkbox
      mt="xs"
      w="full"
      colorScheme={colorScheme === 'gray' ? 'gray' : 'white'}
      sx={{
        '.chakra-checkbox__control:not([data-checked]) svg': {
          opacity: 0,
        },
      }}
      {...registration}
    >
      <Text as="span" size="title3">
        Sign me up for news and offers
      </Text>
    </Checkbox>
  );
}
